import React, { useContext, useState } from "react";

import ProductPreview from "./ProductPreview";
import PriceView from "../common/PriceView";
import DeviceChoices from "./DeviceChoices";
import PromoCode from "../common/PromoCode";
import TotalPrice from "../common/TotalPrice";
import ReferralCode from "../common/ReferralCode";
import { buyNowContext, shippingMethods } from "../BuyNow";
import { DEVICE_TYPES } from "../../../../constants";
import { GuaranteesIcons } from "../common/GuaranteesIcons";

/**
 * This product selection component can be used for multiple purchase flows. There is no text specific to ClearStep / Shapa unless it is explicitly coded per the current purchase flow.
 */
const BPAddonSelection = () => {
  const {
    appInfo,
    lineItems,
    PURCHASE_STAGES,
    thermometerProducts,
    setPurchaseStage,
    shippingStageState,
    setShippingStageState,
    setLineItemsByCategory,
  } = useContext(buyNowContext);

  const businessName = appInfo.name;
  const URLS = {
    "Shapa": 'https://www.myshapa.com/orders/buy-now',
    "MyClearStep": 'https://store.myclearstep.com/orders/buy-now',
  };

  const deviceLineItem = lineItems.find(li => [DEVICE_TYPES.THERMOMETER].includes(li.product.deviceType));
  const selectedDevice = deviceLineItem ? deviceLineItem.product : null;
  const isActiveCheckoutSection = selectedDevice;

  const [previewedDevice, setPreviewedDevice] = useState();

  const proceedToShipping = () => {
    setPurchaseStage(PURCHASE_STAGES.SHIPPING);
  };

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <h2 id="buy-now-header" className="col-lg-12 text-lg-center d-lg-block">
          {`${businessName} Thermometer`}
        </h2>
      </div>
      <GuaranteesIcons/>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-lg-5 offset-lg-1">
            <ProductPreview product={previewedDevice || selectedDevice || thermometerProducts[0]} className="py-lg-5" />
          </div>

          <div className="col-lg-5 mt-4">
            <section className="col-lg-12">
              <section>
                <h4 className={"offset-1 offset-lg-0 text-dark header-txt"}>
                  {`Your ${businessName} purchase includes:`}
                </h4>

                <div className="custom-control custom-checkbox my-3 col-10 offset-1 col-lg-12 offset-lg-0 px-0">
                  <ul>
                    <li className='d-flex'>
                      <i className="fa fa-check teal-text icon-size me-1" style={{ paddingTop: "2px" }}/>
                      <p className="pb-1 description-txt">
                        {`${businessName} FDA-approved thermometer`}
                      </p>
                    </li>

                    <li className='d-flex'>
                      <i className="fa fa-check teal-text icon-size me-1" style={{ paddingTop: "2px" }}/>
                      <p className="pb-1 description-txt">
                        {`Access to ${businessName} app (available in iOS and Android)`}
                      </p>
                    </li>

                    <li className='d-flex'>
                      <i className="fa fa-check teal-text icon-size me-1" style={{ paddingTop: "2px" }}/>
                      <p className="pb-1 description-txt">
                        {`Connection with your team so they can track progress securely through the ${businessName} admin portal`}
                      </p>
                    </li>
                  </ul>
                </div>
              </section>

              <section>
                <div className="custom-control custom-checkbox my-3 col-10 offset-1 col-lg-12 offset-lg-0 px-0">
                  <h4 className={"text-dark header-txt"}>
                    {`Infrared Thermometer Connected to ${businessName} platform:`}
                  </h4>

                  <div className="description-txt text-muted">
                    {`Smart, fast, and accurate thermometer with AI-powered alerts and memory tracking.
                    Features a magnetic cap for easy switching between forehead and ear modes, including a child-specific setting.
                    Seamlessly integrates with ${businessName} for remote monitoring and clinician insights.
                    If you do not already have an active membership or scale, please purchase `}
                    <a href={URLS[businessName]} className='underline' target="_blank" rel="noopener noreferrer">here</a>.
                  </div>
                </div>

                <div className={"disabled-overlay " + (isActiveCheckoutSection ? 'd-none' : 'd-block')}/>

                <DeviceChoices
                  selectedDevice={selectedDevice}
                  devices={thermometerProducts}
                  onHovered={device => setPreviewedDevice(device)}
                  onDeviceSelected={device => {
                    const lineItemUpdates = [];

                    // If a scale doesn't have shipping options available, make sure our state reflects 'standard' shipping.
                    if (!device.shippingOptionsAvailable)
                      setShippingStageState({...shippingStageState, shippingMethod: shippingMethods.standard});

                    lineItemUpdates.push({ product: device, quantity: 1 });
                    setLineItemsByCategory(lineItemUpdates);
                  }}
                />
              </section>
            </section>
            <div className="row row mt-4">
              <section className="col-12">
                <div className={"disabled-overlay " + (isActiveCheckoutSection ? 'd-none' : 'd-block')}/>
                <div className="offset-1 col-10 px-0 offset-lg-0 col-lg-12 px-2">
                  <PromoCode />
                  <ReferralCode />
                  <PriceView hideDecimalIfWhole={true} includeShippingCost={false} className="text-center" />
                </div>

                <div className="my-5 text-center">
                  <div className={"disabled-overlay pay-btn-section " + (isActiveCheckoutSection ? 'd-none' : 'd-block')}>
                  </div>

                  <p className="d-block pb-0 checkout-sub-txt">Subtotal</p>
                  <h1 className="d-block py-2 display-4 fw-bold total-price-txt">${<TotalPrice hideDecimalIfWhole={true} includeShippingCost={false} />}</h1>

                  <div className="text-center py-3">
                    <a className="teal button-link next-button-txt next-step-button" onClick={() => { proceedToShipping(); }}>
                      Proceed to checkout
                    </a>
                  </div>

                  <div className="mt-3 text-center">
                    <p className="text-muted font-italic most-popular">
                      Sales tax and shipping will be calculated at checkout
                    </p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BPAddonSelection;
